class DooPadPlayer extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    const button = this.querySelector('[data-doo-pad-toggle]');
    if (!button) return;
    button.addEventListener('click', () => {
      const paused = this.classList.toggle('is-paused');
      const label = paused ? 'Play animation' : 'Pause animation';
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
    button.hidden = false;
    this.classList.add('is-ready');
  }
}
if (!customElements.get('doo-pad-player')) customElements.define('doo-pad-player', DooPadPlayer);
